import { Button } from '@/components/ui/button';
import { FilterSelect } from '@/modules/common/components';

import { GcrFormOptions, TableFiltersType } from '../types';

interface TableFiltersProps {
  options: GcrFormOptions;
  filters: Partial<TableFiltersType>;
  setFilters: (filters: Partial<TableFiltersType>) => void;
}

export function TableFilters({
  options,
  filters,
  setFilters,
}: TableFiltersProps) {
  const handleFilterChange = (
    filter: keyof TableFiltersType,
    value: string
  ) => {
    setFilters({ [filter]: value });
  };

  return (
    <div className="flex gap-4 pb-5 flex-wrap max-w-[1000px]">
      <div className="flex-1">
        <FilterSelect
          options={options.colors}
          label="Color"
          value={filters.colorId}
          onChange={(value) => handleFilterChange('colorId', value)}
        />
      </div>

      <div className="flex-1">
        <FilterSelect
          options={options.sizes}
          label="Size"
          value={filters.sizeId}
          onChange={(value) => handleFilterChange('sizeId', value)}
        />
      </div>

      <div className="flex-1">
        <FilterSelect
          options={options.types}
          label="Type"
          value={filters.typeId}
          onChange={(value) => handleFilterChange('typeId', value)}
        />
      </div>

      <div className="flex-1">
        <FilterSelect
          options={options.printers}
          label="Printer"
          value={filters.printerId}
          onChange={(value) => handleFilterChange('printerId', value)}
        />
      </div>

      <div className="col-span-3 sm:col-span-1">
        <Button
          variant="outline"
          className="w-full"
          onClick={() =>
            setFilters({
              colorId: '',
              sizeId: '',
              typeId: '',
              printerId: '',
            })
          }
        >
          Clear Filters
        </Button>
      </div>
    </div>
  );
}
